import React, { FC } from 'react';

import { Helmet } from 'react-helmet-async';

const GTM_ID = process.env.GTM_ID;
const GTAG_ID = process.env.GTAG_ID;

type Props = {
  children?: React.ReactNode;
};

const AuthAdditionalAnalyticsScripts: FC<Props> = ({ children }) => {
  return (
    <>
      {/*Google Tag Manager*/}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          // @ts-ignore
          style="display:none;visibility:hidden"
        ></iframe>
      </noscript>
      {/*End Google Tag Manager (noscript)*/}
      <Helmet>
        {/*Google Tag Manager*/}
        <script>
          {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `}
        </script>
        {/*End Google Tag Manager*/}

        {/*Google tag (gtag.js)*/}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id='${GTAG_ID}'"
        ></script>
        <script>
          {`window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          
          gtag('config', '${GTAG_ID}');`}
        </script>
        {/* End Google tag (gtag.js)*/}
      </Helmet>
      {children}
    </>
  );
};
export default AuthAdditionalAnalyticsScripts;
